import { useEffect } from 'react';
import { mapValues } from 'lodash';
import { useSelector } from 'react-redux';

import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';
import { selectSsnHidingEnabled } from '../../../redux/data/selectors';
import {
  makeLocalFieldsValidation,
  useFormState,
  useFormValidation,
} from '../../../hocs/useFormWithValidation';

export const initialState = {
  [PROFILE_FIELDS_TYPES.FIRST_NAME]: null,
  [PROFILE_FIELDS_TYPES.LAST_NAME]: null,
  [PROFILE_FIELDS_TYPES.SSN]: null,
  [PROFILE_FIELDS_TYPES.DOB]: null,
  [PROFILE_FIELDS_TYPES.LOGIN]: null,
};

export function usePatientInfoForm(state, errors) {
  const { formState, handleFormChange } = useFormState(initialState);
  const { validateErrors, clearErrors } = useFormValidation(errors);

  const ssnHidingEnabled = useSelector(selectSsnHidingEnabled);

  const isValid = makeLocalFieldsValidation([
    PROFILE_FIELDS_TYPES.FIRST_NAME,
    PROFILE_FIELDS_TYPES.LAST_NAME,
    PROFILE_FIELDS_TYPES.DOB,
    PROFILE_FIELDS_TYPES.LOGIN,
    ...(!ssnHidingEnabled ? [PROFILE_FIELDS_TYPES.SSN] : []),
  ])(formState);

  useEffect(() => {
    if (state) {
      const populate = mapValues(initialState, (value, key) => {
        return state[key] || null;
      });

      handleFormChange(populate);
    }
  }, [state]);

  return {
    formState,
    handleFormChange,
    validateErrors,
    clearErrors,
    isValid,
  };
}



// WEBPACK FOOTER //
// ./src/components/DashboardRecord/utils/usePatientInfoFormState.js